import React from "react";
import PropTypes from 'prop-types';
import { Link, useLocation } from "react-router-dom";

import styles from './breadcrumbs.module.css';
import Text from "../text";
import Breadcrumbs from "./Breadcrumbs";
/**
 * 
 * @param {object} nameMap The Route to the display name map
 * @returns 
 */
const RouteAwareCrumbs = ({maxItems,separator=">",nameMap}) => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    return(
        <Breadcrumbs maxItems={maxItems} separator={separator} className={styles.Route}>
            {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;

            return last ? (
            <Text color="primary" variant="xs" style={{color:"var(--secondary-color)"}} key={to}>
                {nameMap[to]}
            </Text>
            ) : (
            <Link underline="hover" style={{color:"var(--secondary-text)"}}
            className="hover:link"
             color="inherit" to={to} key={to}>
                {nameMap[to]}
            </Link>
            );
        })}
        </Breadcrumbs>
    )
}

RouteAwareCrumbs.propTypes = {
    nameMap: PropTypes.object
}

export default RouteAwareCrumbs;
